/// <reference types="google.maps" />

import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MapMarker } from '@angular/google-maps';

import { SessionService } from 'src/app/shared/services';

import { GoogleMapsLoaderService } from '../shared/google-maps-loader.service';
import { DOCUMENT } from '@angular/common';

export interface MapsMarkConfig {
  title?: string;
  label?: string;
  modalClass?: string;
  okText?: string;
  cancelText?: string;
  position: google.maps.LatLngLiteral;
  editing?: boolean;
  zoom: number;
}

@Component({
  selector: 'app-maps-mark',
  templateUrl: './maps-mark.component.html',
  styleUrls: ['./maps-mark.component.css'],
  providers: [GoogleMapsLoaderService]
})
export class MapsMarkComponent implements OnDestroy {
  private resolve: any;
  private reject: any;

  public options: google.maps.MapOptions = {
    center: {
      lat: -18.9938929,
      lng: -40.3970775
    },
    mapTypeId: 'hybrid',  // google.maps.MapTypeId.HYBRID,
    styles: [
      {
        elementType: 'all',
        featureType: 'landscape',
        stylers: []
      }
    ],
    zoom: 11
  };

  public markerOptions: google.maps.MarkerOptions = {
    draggable: true
  };

  public config: MapsMarkConfig = null;

  @ViewChild('marker') mapMarker: MapMarker;

  constructor(
    private bsModalRef: BsModalRef,
    private sessionService: SessionService,
    public googleMapsLoaderService: GoogleMapsLoaderService,
    @Inject(DOCUMENT) private document: any
  ) {

  }

  ngOnDestroy() {
    this.removeGoogleMapScript();
  }

  private setMapOptions(): void {
    if (!this.config.position) {
      this.config.position = {lat: null, lng: null};
    }

    if (!this.config.position.lat) {
      this.config.position.lat = -18.9117057;
      this.config.position.lng = -40.3496894;
      this.config.zoom = 10;
    }

    this.options.center.lat = this.config.position.lat;
    this.options.center.lng = this.config.position.lng;
    this.options.zoom = this.config.zoom;

    this.markerOptions.draggable = this.config.editing;
  }

  public setOption(resolve: any, reject: any, config: MapsMarkConfig) {
    this.resolve = resolve;
    this.reject = reject;
    this.config = config;

    this.setMapOptions();

    if (!this.config.position.lat) {
      this.sessionService.userData().subscribe(data => {
        this.config.position.lat = data.unit.latitude;
        this.config.position.lng = data.unit.longitude;
        this.setMapOptions();
      });
    }
  }

  public ok(event: Event) {
    this.resolve(this.mapMarker.getPosition().toJSON());
    this.bsModalRef.hide();
  }

  public cancel(event: Event) {
    this.reject(false);
    this.bsModalRef.hide();
  }

  removeGoogleMapScript() {
    // todo: temp workaround for 'You have included the Google Maps API multiple times on this page'
    const keywords = ['maps.googleapis'];

    // Remove google from BOM (window object)
    // @ts-ignore
    window.google = undefined;

    // Remove google map scripts from DOM
    const scripts = this.document.head.getElementsByTagName('script');
    for (let i = scripts.length - 1; i >= 0; i--) {
      const scriptSource = scripts[i].getAttribute('src');
      if (scriptSource != null) {
        if (keywords.filter(item => scriptSource.includes(item)).length) {
          scripts[i].remove();
          // scripts[i].parentNode.removeChild(scripts[i]);
        }
      }
    }
  }

}
